import { CreateAuthentication } from "@musicaudienceexchange/firebase-auth-ui";

export const { useUser, UserContext, UserProvider } = CreateAuthentication({
  firebaseAuthDomain: process.env.REACT_APP_FIREBASE_AUTHDOMAIN,
});
